module.exports = __webpack_public_path__ + "nunito-sans-latin-800.6a4c29ad18bd8072a9a9d2443d0e340e.woff2";